<section class="line-item-modal-container">
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <div class="card-body p-2">
                <div class="d-flex justify-content-between mt-2 mb-4">
                    <p class="mb-0">
                        <span class="fa fa-check-circle me-2 text-success"></span>
                        PO #PO1340089 has been created successfully for PR# PR100282.
                    </p>
                </div>
                <div class="table-responsive">
                    <table class="table table-striped">
                        <thead class="table-active">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Line Item#</th>
                                <th scope="col">Supplier Name</th>
                                <th scope="col">Final Offer</th>
                                <th scope="col">Tax</th>
                                <th scope="col">Quantity</th>
                                <th scope="col">Total Price (Including Tax)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let lineItemMap of lineNumberQuotationMap | keyvalue; let i = index">
                                <th scope="row">{{i+1}}.</th>
                                <td>{{lineItemMap?.key}}</td>
                                <td>
                                    {{lineItemMap?.value?.rfq_supplier_quotation?.supplier?.bill_to}}
                                </td>
                                <td>
                                    <ng-container *ngIf="lineItemMap?.value?.rfq_supplier_quotation?.quotation_details?.length">
                                        {{ lineItemMap.value.rfq_supplier_quotation.quotation_details[0].line_item[0]?.material_master?.currency }}
                                        {{ lineItemMap.value.rfq_supplier_quotation.quotation_details[0]?.final_price | number:'1.1-3' }}
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container *ngIf="lineItemMap?.value?.rfq_supplier_quotation?.quotation_details?.length">
                                        {{ lineItemMap.value.rfq_supplier_quotation.quotation_details[0].tax}}%
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container *ngIf="lineItemMap?.value?.rfq_supplier_quotation?.quotation_details?.length">
                                        {{ lineItemMap.value.rfq_supplier_quotation.quotation_details[0].quantity}}
                                    </ng-container>
                                </td>
                                <td>
                                    <ng-container *ngIf="lineItemMap?.value?.rfq_supplier_quotation?.quotation_details?.length">
                                        {{ lineItemMap.value.rfq_supplier_quotation.quotation_details[0].line_item[0]?.material_master?.currency }}
                                        {{ lineItemMap.value.rfq_supplier_quotation.quotation_details[0].total_price | number:'1.1-3'}}
                                    </ng-container>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <div>
            <button class="btn btn-outline-primary mx-2" (click)="bsModalRef.hide()">Cancel</button>
            <button class="btn btn-primary mx-2 text-white" (click)="trackPOProgress()">Track PO Progress</button>
        </div>
    </div>
</section>